export const SMARTPHONE_LESSONS_PT = [
  {
    id: 'smartphone-1',
    numero: 1,
    titre: "O essencial — ecrã e aplicações",
    sousTitre: "Para principiantes absolutos",
    contexte: "O smartphone parece complicado no início. Aqui estão o essencial da utilização diária.",
    explication: [
      "**Ligar e desligar**: prima longamente o botão de energia (normalmente no lado direito). Para desligar, escolha 'desligar'.",
      "**Gestos básicos**: toque para abrir, toque longo para opções, deslize para navegar, dois dedos para zoom.",
      "**Voltar atrás**: botão da seta ← ou deslize da margem esquerda para a página anterior.",
      "**As aplicações**: ícones no ecrã principal. Prima para abrir. Prima longamente para mover ou apagar.",
      "**Fechar aplicações**: prima o botão dos quadrados (gestor de aplicações) e deslize as aplicações não utilizadas.",
    ],
    question: "Como ampliar um texto ou imagem no telemóvel?",
    options: [
      { id: 'a', text: "Colocando dois dedos e afastando-os", correct: true },
      { id: 'b', text: "Tocando três vezes", correct: false },
      { id: 'c', text: "Não é possível ampliar no telemóvel", correct: false },
    ],
    explication_reponse: "O zoom com dois dedos funciona em todo o lado — navegador, fotos, PDF, mapas. Coloque dois dedos no ecrã e afaste-os para ampliar.",
  },
  {
    id: 'smartphone-2',
    numero: 2,
    titre: "Chamadas e mensagens",
    sousTitre: "Comunicar facilmente",
    contexte: "Fazer e receber chamadas, enviar SMS e WhatsApp. O essencial passo a passo.",
    explication: [
      "**Fazer uma chamada**: abra a aplicação do telefone (ícone de auscultador), introduza o número ou escolha dos contactos, prima o ícone verde.",
      "**Receber uma chamada**: deslize para a esquerda ou prima o ícone verde. Para rejeitar, deslize para a direita ou prima o ícone vermelho.",
      "**Mensagens SMS**: aplicação de mensagens (ícone de balão de conversa). Escreva, escolha o contacto, prima enviar.",
      "**WhatsApp**: mensagens e chamadas gratuitas pela internet. Crie conta com o número de telemóvel — gratuito.",
      "**Altifalante**: durante a chamada, prima 'altifalante' para ouvir melhor sem usar as mãos.",
    ],
    question: "Como rejeitar uma chamada recebida?",
    options: [
      { id: 'a', text: "Premindo o ícone vermelho ou deslizando", correct: true },
      { id: 'b', text: "Desligando o telemóvel", correct: false },
      { id: 'c', text: "Não é possível rejeitar uma chamada recebida", correct: false },
    ],
    explication_reponse: "O ícone vermelho rejeita a chamada. Em alguns telemóveis deslize para baixo ou para a direita. A chamada rejeitada vai para o correio de voz.",
  },
  {
    id: 'smartphone-3',
    numero: 3,
    titre: "Instalar aplicações com segurança",
    sousTitre: "Apenas Play Store e App Store",
    contexte: "Quer instalar a aplicação da CAF, Ameli ou do banco. Como fazê-lo com segurança?",
    explication: [
      "**Google Play Store** (Android) ou **App Store** (iPhone): são as únicas lojas oficiais — instale apenas a partir daqui.",
      "**Pesquisar a aplicação**: escreva o nome na barra de pesquisa da loja. Atenção a aplicações semelhantes ao original.",
      "**Aplicação oficial ou não**: verifique o nome do programador — a aplicação oficial da CAF é desenvolvida por 'CAF — Caisse d'Allocations Familiales'.",
      "**Actualizações**: aplique as actualizações das aplicações regularmente — corrigem falhas de segurança.",
      "**Nunca instale a partir de links**: não instale nenhuma aplicação a partir de um link em SMS ou email — risco de fraude.",
    ],
    question: "Onde deve instalar a aplicação da CAF no telemóvel?",
    options: [
      { id: 'a', text: "Apenas no Google Play Store ou App Store", correct: true },
      { id: 'b', text: "Directamente no site caf.fr", correct: false },
      { id: 'c', text: "A partir de um link numa mensagem SMS", correct: false },
    ],
    explication_reponse: "As lojas oficiais são o único lugar seguro para instalar aplicações. Um link em SMS para instalar uma aplicação é normalmente uma fraude.",
  },
  {
    id: 'smartphone-4',
    numero: 4,
    titre: "Segurança e privacidade",
    sousTitre: "Proteger o telemóvel e os dados",
    contexte: "O telemóvel contém informações pessoais. Como protegê-lo?",
    explication: [
      "**Código de bloqueio**: use um PIN de 6 dígitos ou impressão digital para bloquear o telemóvel. Essencial em caso de perda ou roubo.",
      "**Em caso de perda**: iPhone: icloud.com/find. Android: myaccount.google.com — localize-o ou apague os dados remotamente.",
      "**Permissões**: ao instalar uma aplicação, não dê permissões desnecessárias — uma aplicação de lanterna não precisa de acesso à câmara.",
      "**Rede WiFi**: não se ligue a redes desconhecidas. Use os dados móveis para operações bancárias.",
      "**Cópia de segurança**: active a cópia de segurança automática (iCloud ou Google) para guardar fotos e informações.",
    ],
    question: "Perdeu o telemóvel Android. Como apagar os dados remotamente?",
    options: [
      { id: 'a', text: "Através de myaccount.google.com noutro dispositivo", correct: true },
      { id: 'b', text: "Não é possível apagar os dados remotamente", correct: false },
      { id: 'c', text: "Apenas contactando o operador telefónico", correct: false },
    ],
    explication_reponse: "O Google Find My Device em myaccount.google.com permite localizar o telemóvel, emitir um som, bloqueá-lo ou apagar todos os dados remotamente — excelente protecção.",
  },
];
